const Pricing = () => {
  // redirect to new pricing page if user tries to access old page
  window.location.replace("/app/pricing");
  return null;
};

export default Pricing;
